import * as React from "react";

import type { AccountDetails } from "@/apis/gql/types";
import { MultiSelect, type OptionValue } from "@/components/ui/multi-select";

export const SpecialRulesCell = ({
  value,
  saveHandler,
  className,
  key,
}: {
  value: AccountDetails;
  key: string;

  saveHandler: (value: Partial<AccountDetails>) => Promise<void>;
  className?: string;
}) => {
  const [account, setAccount] = React.useState<Partial<AccountDetails>>(value);

  const onChange = (value: OptionValue[] | null) => {
    const _value = value ?? [];
    const updateValues = mapTextToRules(_value);
    const newValue = {
      ...account,
      ...updateValues,
    };

    setAccount(newValue);
    saveHandler(updateValues);
  };

  const frameworksList = [
    { value: "buExport", label: "Kein BU" },
    { value: "serviceDateExport", label: "Kein Datum" },
    { value: "faktor2", label: "Faktor 2" },
    { value: "automatic", label: "Automatik" },
  ];

  return (
    <MultiSelect
      key={key}
      options={frameworksList}
      onValueChange={onChange}
      placeholder={"Regel Wählen"}
      defaultValue={mapRulesToText(account)}
      disabledValues={[]}
    />
  );
};

function mapRulesToText(account: Partial<AccountDetails>): string[] {
  const rules: string[] = [];
  if (account.buExport === false) rules.push("buExport");
  if (account.serviceDateExport === false) rules.push("serviceDateExport");
  if (account.faktor2 === true) rules.push("faktor2");
  if (account.automatic === true) rules.push("automatic");
  return rules;
}

function mapTextToRules(text: OptionValue[]): Partial<AccountDetails> {
  const account: Partial<AccountDetails> = {
    buExport: true,
    serviceDateExport: true,
    faktor2: false,
    automatic: false,
  };
  for (const rule of text) {
    if (rule === "buExport") account.buExport = false;
    if (rule === "serviceDateExport") account.serviceDateExport = false;
    if (rule === "faktor2") account.faktor2 = true;
    if (rule === "automatic") account.automatic = true;
  }
  return account;
}
